<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20">
        </div>
        <NavBar />
      </aside>
      
      <!-- Main Content -->
      <div class="flex flex-col flex-1">
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
          <h2 class="text-xl font-semibold">Add a Node</h2>
        </header>

        <main class="p-6">
          <div class="bg-gray-800 p-6 rounded-lg shadow-md w-full max-w-2xl mx-auto">
            <h2 class="text-xl font-semibold mb-4">Add Node</h2>
            
            <form @submit.prevent="addNode">
              <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Node Name</label>
                <input v-model="node.name" type="text" class="w-full p-3 bg-gray-700 rounded-lg focus:ring focus:ring-blue-500">
              </div>
              
              <div class="mb-4">
                <label class="block text-sm font-medium mb-1">IP Address</label>
                <input v-model="node.ip" type="text" class="w-full p-3 bg-gray-700 rounded-lg focus:ring focus:ring-blue-500">
              </div>
              
              <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Location</label>
                <input v-model="node.location" type="text" class="w-full p-3 bg-gray-700 rounded-lg focus:ring focus:ring-blue-500">
              </div>
              
              <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Port</label>
                <input v-model="node.port" type="number" class="w-full p-3 bg-gray-700 rounded-lg focus:ring focus:ring-blue-500">
              </div>
              
              <div class="mb-4">
                <label class="block text-sm font-medium mb-1">Description</label>
                <textarea v-model="node.description" class="w-full p-3 bg-gray-700 rounded-lg focus:ring focus:ring-blue-500"></textarea>
              </div>
              
              <button type="submit" class="w-full p-3 bg-blue-500 rounded-lg hover:bg-blue-600 transition">
                Add Node
              </button>
            </form>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import NavBar from '@/components/adminnav.vue';
  import axios from 'axios';
  
  export default {
    components: { NavBar },
    data() {
      return {
        node: {
          name: '',
          ip: '',
          location: '',
          port: '',
          description: ''
        }
      };
    },
    methods: {
      async addNode() {
        try {
          await axios.post('https://api.syniac.com:3000/api/nodes', this.node, { withCredentials: true });
          alert('Node added successfully!');
          this.$router.push('/admin/nodes');
        } catch (error) {
          console.error('Error adding node:', error);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  input, textarea {
    outline: none;
  }
  </style>
